import type { ImportedPageRange } from './documentImportLimits';

/**
 * The last page-limited batch imported from each document into each piece of content, so a long
 * document resumes at its next batch whenever its viewer reopens — across the sidebar closing,
 * tab switches, the editor remounting, and the Upload Document flow handing over to the editor.
 * Kept for the page's lifetime only: a reload starts fresh.
 */
const lastBatches = new Map<string, ImportedPageRange>();

const progressKey = (modelType: string, modelId: string, documentId: string) =>
  `${modelType}:${modelId}:${documentId}`;

export function getLastImportedBatch(
  modelType: string,
  modelId: string,
  documentId: string,
): ImportedPageRange | null {
  return lastBatches.get(progressKey(modelType, modelId, documentId)) ?? null;
}

export function recordImportedBatch(
  modelType: string,
  modelId: string,
  documentId: string,
  range: ImportedPageRange,
): void {
  lastBatches.set(progressKey(modelType, modelId, documentId), range);
}

export function clearImportProgress(): void {
  lastBatches.clear();
}
